import React from 'react';
import css from './WhyParentsChoose.module.css';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';
import { FormattedMessage, injectIntl, intlShape } from '../../../../../util/reactIntl';

const WhyParentsChooseList = [
    {
        image: <IconCard type="safe" />,
        titleId: "WhyParentsChoose.item1.title",
        descriptionId: "WhyParentsChoose.item1.description"
    },
    {
        image: <IconCard type="speaking" />,
        titleId: "WhyParentsChoose.item2.title",
        descriptionId: "WhyParentsChoose.item2.description"
    },
    {
        image: <IconCard type="schedule" />,
        titleId: "WhyParentsChoose.item3.title",
        descriptionId: "WhyParentsChoose.item3.description"
    },
    {
        image: <IconCard type="pricing" />,
        titleId: "WhyParentsChoose.item4.title",
        descriptionId: "WhyParentsChoose.item4.description"
    },
    {
        image: <IconCard type="msa" />,
        titleId: "WhyParentsChoose.item5.title",
        descriptionId: "WhyParentsChoose.item5.description"
    },
    {
        image: <IconCard type="homework" />,
        titleId: "WhyParentsChoose.item6.title",
        descriptionId: "WhyParentsChoose.item6.description"
    },
];

function WhyParentsChoose() {
    
    return (
        <div className={css.whyParentsChooseContainer}>
            <div className={css.leftSide}>
                <div className={css.mainHeading}>
                    <FormattedMessage id="WhyParentsChoose.mainHeading" />                                
                </div>
                <div className={css.subHeading}>
                    <FormattedMessage id="WhyParentsChoose.subHeading" />
                </div>
            </div>
            <div className={css.rightSide}>
                <ul>
                    {WhyParentsChooseList.map((item, i) => {
                        return (
                            <li key={i}>
                                <div className={css.icon}>{item.image}</div>
                                <div className={css.listContent}>
                                    <div className={css.title}>
                                        <FormattedMessage id={item.titleId} />
                                    </div>
                                    <div className={css.description}>
                                        <FormattedMessage id={item.descriptionId} />
                                    </div>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default WhyParentsChoose